var React = require('react');

function Content (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M32 0L36 6H30L26 0H22L26 6H20L16 0H12L16 6H10L6 0H4C1.8 0 0.02 1.8 0.02 4L0 28C0 30.2 1.8 32 4 32H36C38.2 32 40 30.2 40 28V0H32ZM18.5 22.5L16 28L13.5 22.5L8 20L13.5 17.5L16 12L18.5 17.5L24 20L18.5 22.5ZM29.88 15.88L28 20L26.12 15.88L22 14L26.12 12.12L28 8L29.88 12.12L34 14L29.88 15.88Z","fill":"currentColor"}));
}

Content.defaultProps = {"width":"40","height":"32","viewBox":"0 0 40 32","fill":"none"};

module.exports = Content;

Content.default = Content;
